module.exports = __webpack_public_path__ + "media/images/flags/lr-2bba212985d834dbb686230b790c0b98.svg";